export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/readiwriterspelling-full-cb46588475f5e8d891d7f7a42c8458aa.svg";